/**
 * DAT-850 · How another surface (the Hiring page's "What counts as an absence?" panel) asks the Team page to open
 * on the Call-in reasons tab. Shape of `AgencyWages/deepLink.ts`: the tab is local state, not URL-backed filter
 * state, so Team applies the param once and strips it.
 */

export const TEAM_CALL_IN_REASONS_PARAM = "call_in_reasons";

const TEAM_CALL_IN_REASONS_VALUE = "true";

export function buildTeamCallInReasonsUrl(departmentId: string): string {
	return `/${departmentId}/team?${TEAM_CALL_IN_REASONS_PARAM}=${TEAM_CALL_IN_REASONS_VALUE}`;
}

export function isTeamCallInReasonsRequested(params: URLSearchParams): boolean {
	return params.get(TEAM_CALL_IN_REASONS_PARAM) === TEAM_CALL_IN_REASONS_VALUE;
}
